// extracted by css-extract-rspack-plugin
export default {"findMoreMessage":"_6bf35ae9"};